import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getCity, setCity, getAddressImagingPackageList } from "../../../Redux/Actions";
import { MdLocationOn } from "react-icons/md";
import { Modal } from "react-responsive-modal"
import imagingAddressSelectStyles from "./ImagingAddressPopUpModal.module.css"
import { Divider } from "@mui/material";
import { useHistory } from "react-router-dom";

const ImagingAddressBar = ({ keyIdx, price, center_address, selectedAddress, setSelectedAddress }) => {

  const handleAddressSelect = (e) => {
    // console.log("event", e);
    // let eles = document.getElementsByName("imaging-address-select-div")
    // console.log("eles", eles);
    // console.log('center_address', center_address);
    setSelectedAddress(center_address);
  }
  // console.log("key", keyIdx);
  return (
    <div
      className={imagingAddressSelectStyles.addressDiv}
    >
      <label
        htmlFor={"imaging-address-" + keyIdx}
        className={imagingAddressSelectStyles.addressDivDetails}
      >
        <span className={imagingAddressSelectStyles.addressDivAddressHead}>Address</span>
        <p className={imagingAddressSelectStyles.addressDivAddress}>{center_address?.center_address?.address ?? ""}</p>
        <span className={imagingAddressSelectStyles.addressDivPriceHead}>Price</span>
        <span className={imagingAddressSelectStyles.addressDivPrice}>&#8377; {price}</span>
      </label>
      <input
        type="radio"
        id={"imaging-address-" + keyIdx}
        // value={center_address?.center_address}
        name="imaging-address-select-div"
        checked={selectedAddress === center_address}
        onChange={handleAddressSelect}
        className={imagingAddressSelectStyles.addressDivRadio}
      />
    </div>
  )
}

const ImagingAddressSelect = ({ slug, type }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [displayCitySelect, setDisplayCitySelect] = useState(false);
  const [searchCity, setSearchCity] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");

  let citiesObj = useSelector((state) => state.navCityList.navCities);
  let cities = citiesObj?.cities ?? [];

  const cityState = useSelector((state) => state.cityOnTopNav.citySelect);

  let imagingAddressesPackageWise = useSelector((state) => state.getImgPackagesAddressReducer.ImgPackagesAddress);

  useEffect(() => {
    if (!(cities?.length)) {
      dispatch(getCity());
    }
    dispatch(getAddressImagingPackageList(slug, cityState))
  }, [cityState])

  const handleSearchCityChange = (e) => {
    setSearchCity(e.target.value)
    if (e.target.value !== "") {
      !displayCitySelect && setDisplayCitySelect(true);
    } else {
      setDisplayCitySelect(false)
    }
  }

  const handleCitySelect = (city) => {
    // console.log("city", city);
    dispatch(setCity(city));
    localStorage.setItem("city", city);
    setSearchCity("");
    setDisplayCitySelect(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("hospAddr", JSON.stringify(selectedAddress));
    localStorage.setItem('packageSlug', '/imaging/' + slug)
    if (type === "book") {
      // window.location.href = process.env.RAZZLE_APP_BASE_URL + "/imaging/" + slug + "-" + cityState;
      history.push(`/imaging/${slug}${cityState ? "-" + cityState : ""}`);
    }
  }

  return (
    <div className={imagingAddressSelectStyles.container}>
      <div className={imagingAddressSelectStyles.cityDiv}>
        <span className={imagingAddressSelectStyles.enterCity}>
          Enter City
        </span>
        <div className={imagingAddressSelectStyles.citySelect}>
          <MdLocationOn className={imagingAddressSelectStyles.locIcon} />
          <input
            type="text"
            placeholder={cityState}
            className={imagingAddressSelectStyles.cityInput}
            value={searchCity}
            onChange={(e) => handleSearchCityChange(e)}
            spellCheck="false"
          />
        </div>
        {displayCitySelect &&
          <div className={imagingAddressSelectStyles.cityList}>
            {cities
              .filter((city) => {
                let res;
                city.split("_").forEach((partialName, index) => {
                  if (partialName.length < searchCity.length) {
                    res = false;
                    return;
                  }
                  res = true;
                  for (let i = 0; i < searchCity.length; i++) {
                    if (partialName[i].toLowerCase() !== searchCity[i].toLowerCase()) {
                      res = false;
                      break;
                    }
                  }
                });
                return res;
              })
              // .sort((a, b) => {
              //   for (let i = 0; i < searchCity.length; i++) {
              //     // console.log("a", a, "b", b);
              //     if (a.charAt(i) && b.charAt(i)) {
              //       let charA = a[i].toLowerCase();
              //       let charB = b[i].toLowerCase();
              //       let charC = searchCity[i].toLowerCase();
              //       if (charA === charC && charB !== charC) {
              //         return -1;
              //       }
              //       else if (charA !== charC && charB === charC) {
              //         return 1;
              //       }
              //     }
              //     return 0;
              //   }
              // })
              .map((filteredCity, index) => {
                if (index < 3) {
                  return (
                    <div
                      key={index}
                      className={imagingAddressSelectStyles.city}
                      style={{ textTransform: "capitalize" }}
                      onClick={() => handleCitySelect(filteredCity)}
                    >
                      {filteredCity.replaceAll("_", " ")}
                    </div>
                  )
                }
              })
            }
          </div>
        }
      </div>
      <Divider style={{ margin: "2rem 0" }} />
      <div className={imagingAddressSelectStyles.addressSelect}>
        {imagingAddressesPackageWise?.length
          ? <>
            <span
              style={{
                color: "#707070",
                fontSize: "2rem",
                fontWeight: "600",
              }}
            >
              Redcliffe Partner Centres
            </span>
            <p
              style={{
                color: "#a7a7a7",
                fontSize: "1.7rem",
                fontWeight: "400",
                marginLeft: "1rem"
              }}
            >
              Select from our world class centres
            </p>
            <form
              onSubmit={(e) => handleSubmit(e)}
              className={imagingAddressSelectStyles.addressForm}
            >
              <div className={imagingAddressSelectStyles.addressFormAddresses}>
                {imagingAddressesPackageWise.map((address, index) => (
                  <div key={index}>
                    <ImagingAddressBar
                      keyIdx={index}
                      center_address={address?.center_address}
                      price={address.offer_price}
                      selectedAddress={selectedAddress}
                      setSelectedAddress={setSelectedAddress}
                    />
                  </div>
                ))}
              </div>
              <button
                type="submit"
                className={imagingAddressSelectStyles.addressFormSubmit}
                style={{
                  cursor: selectedAddress === "" ? "grab" : "pointer",
                  backgroundColor: selectedAddress === "" ? "#db406a" : "#e5184e",
                  pointerEvents: selectedAddress === "" ? "none" : "all",
                }}
              >
                Submit
              </button>
            </form>
          </>
          : <span
            style={{
              color: "#707070",
              fontSize: "2rem",
              fontWeight: "600",
              display: "block",
              textAlign: "center",
            }}
          >
            No Centres Found
          </span>
        }
      </div>
    </div>
  )
}


const ImagingAddressPopUpModal = ({ open, onModalClose, slug, type }) => {

  // const [open, setOpen] = useState(true);
  // console.log("setOpen", setOpen, "open", setOpenImagingAddressModal);
  // const handleClose = () => {
  //   setOpen(false);
  //   setOpenImagingAddressModal(false);
  // }

  return (
    <Modal
      open={open}
      onClose={onModalClose}
      center
      classNames={{
        root: imagingAddressSelectStyles.modalRoot,
        overlay: imagingAddressSelectStyles.modalOverlay,
        modal: imagingAddressSelectStyles.modalModal,
      }}
    >
      <ImagingAddressSelect
        slug={slug}
        type={type}
      />
    </Modal>
  )
}

ImagingAddressPopUpModal.defaultProps = {
  type: "book",
}

export {
  ImagingAddressPopUpModal as default,
  ImagingAddressSelect,
}